import { Link } from "react-router-dom";
import styled, { css, DefaultTheme, ThemeProps } from "styled-components";

export const Container = styled.div`
    position: relative;
    z-index: 1;

    display: flex;
    flex-flow: column;
    align-items: center;

    user-select: none;

    font-size: 1rem;

    background: white;

    & > div {
        width: 100%;

        &:first-child {
            flex: 0 0 6rem;
        }

        &:nth-child(2) {
            flex: 1;
        }

        &:last-child {
            flex: 0 0 4rem;
        }
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;

    font-size: 1.4rem;
    font-weight: ${(props) => props.theme.fontWeight.bolder};
    color: ${(props) => props.theme.colors.neutral[800]};

    & > *:first-child {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 12rem;
        height: 2.5rem;
    }

    & > *:last-child {
        flex: 0 0 1px;
        border: none;
        border-top: 1px solid ${(props) => props.theme.colors.neutral[125]};
        width: 80%;
        margin: 0;
    }
`;

export const LinkContainer = styled.div`
    display: flex;
    flex-flow: column;
    margin-top: 1rem;
`;

export const SharedLinkCSS = css`
    text-decoration: none;
    height: 2.8rem;

    font-weight: ${(props) => props.theme.fontWeight.bold};

    display: flex;
    align-items: center;

    & > *:nth-child(2) {
        margin-left: 1rem;
    }

    &:hover {
        cursor: ${(props: ThemeProps<DefaultTheme> & { $active: boolean }) =>
            (!props.$active && "pointer") || "default"};
        background: ${(
            props: ThemeProps<DefaultTheme> & { $active: boolean }
        ) => !props.$active && props.theme.colors.neutral[25]};
        color: ${(props: ThemeProps<DefaultTheme> & { $active: boolean }) =>
            !props.$active && props.theme.colors.primary[100]};
    }
`;

export const StyledLink = styled(Link)<{ $active: boolean }>`
    ${SharedLinkCSS};
    color: ${({ $active, theme }) =>
        $active ? theme.colors.primary[400] : theme.colors.neutral[375]};
    background: ${({ $active, theme }) =>
        $active ? theme.colors.neutral[35] : "inherit"};
    padding-left: 2rem;
    border-left: ${({ $active, theme }) =>
        $active
            ? `solid 4px ${theme.colors.primary[600]}`
            : "solid 4px transparent"};
`;

export const StyledSublink = styled(Link)<{ $active: boolean }>`
    ${SharedLinkCSS};
    height: 2.4rem;
    color: ${({ $active, theme }) =>
        $active ? theme.colors.primary[200] : theme.colors.neutral[375]};
    background: ${({ $active, theme }) =>
        $active ? theme.colors.neutral[25] : "inherit"};
    padding-left: 4.2rem;
`;

export const StyledLogout = styled.div`
    display: flex;
    justify-content: center;

    font-weight: ${(props) => props.theme.fontWeight.bold};

    & > * {
        background: ${(props) => props.theme.colors.neutral[100]};
        color: ${(props) => props.theme.colors.neutral[200]};
        width: 10rem;
        height: 2rem;

        border-radius: 0.2rem;

        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            background: ${(props) => props.theme.colors.danger[100]};
            color: ${(props) => props.theme.colors.danger[400]};
            cursor: pointer;
        }

        @media (max-width: 768px) {
            width: 60%;
        }
    }
`;
